import React, { useEffect, useState } from "react";

import RRLogsFServ from "../renderRows/RRLogsFServ.js";

import './FueraServicioSubtabla.css'
import { createEstructuraLogsFServ, estructuraLogsFServ } from "../../utils/estructuras.js";

const FueraServicioSubtabla = ({logsActivo,fServChecked,handleChenge, opcionesUsers, usuario, modo='Nuevo', fServOriginal, tablaSeleccionada, fServFiles, onFServFileChange}) => {

    const handleChange = (l = {}, i, prop='', value=undefined) => {
        let logsUpdated = logsActivo.slice();
        let fechaFormateada;
        if(prop != '' && value != undefined && Object.keys(l).length == 0){
            if(prop == 'fecha'){
                fechaFormateada = value;
                logsUpdated[i][prop] = fechaFormateada;
            }
            if(prop == 'evento'){
                if(logsUpdated[i]?.evento.value == ''){
                    logsUpdated.push({...createEstructuraLogsFServ(), user: {userName: usuario.userName, label: usuario.userName, value: usuario.userName, comUserID: usuario._id}});
                }
            }
            logsUpdated[i][prop] = value;
            handleChenge({},'logsFServ',logsUpdated);                         
        }
    }

    const handleDelete = (log, index) => {
        let actualLogs = logsActivo.slice();
        if(log.fecha != '' && log.evento.value != ''){
            //Si la fila tenia un archivo adjunto (pendiente o ya existente), se dispara la limpieza:
            //  - Pendiente (ADD): se descarta antes de subir a S3.
            //  - Existente: se marca como DELETE para eliminarlo de S3 al guardar.
            if(fServFiles?.some(f => f.rowKey === log.rowKey && f.accion !== 'DELETE')){
                onFServFileChange(index, log.rowKey, null);
            }
            let logsToUpdate = actualLogs.filter((p,i) => i != index);
            handleChenge({},'logsFServ',logsToUpdate);
        }
    }

    useEffect(() => {
        if(modo != 'Nuevo' && modo != 'Vista'){
            if(fServChecked != fServOriginal){
                let eventoObj = (fServChecked) ? {value:'FSERV', label:'Fuera de Servicio'} : {value:'DISPO', label:'Disponible'};
                let newLogs;
                if(logsActivo[0].fecha == ''){
                    newLogs = [{rowKey:crypto.randomUUID(),fecha:new Date().toISOString().slice(0, 16),evento:{...eventoObj},textAdic:''},...logsActivo];
                }else if(logsActivo[logsActivo.length-1].fecha == ''){
                    let logsCompleted = logsActivo.filter(l => l.fecha != '');
                    newLogs = [...logsCompleted,{rowKey:crypto.randomUUID(),fecha:new Date().toISOString().slice(0, 16),evento:{...eventoObj},textAdic:''},{...createEstructuraLogsFServ(), fecha:''}]
                }
                else{
                    newLogs = [...logsActivo,{rowKey:crypto.randomUUID(),fecha:new Date().toISOString().slice(0, 16),evento:{...eventoObj},textAdic:''}];
                }
                handleChenge({},'logsFServ',newLogs);
            }else{
                let newLogs = logsActivo.slice();
                newLogs = newLogs.filter((p,i) => i != newLogs.length - 1);
                handleChenge({},'logsFServ',newLogs);                         
            }
        }else if(modo == 'Nuevo' && fServChecked){
            let newLogs = logsActivo.slice();
            newLogs[0].fecha = new Date().toISOString().slice(0, 16);
            newLogs[0].evento = {value:'FSERV', label:'Fuera de Servicio'};
            handleChenge({},'logsFServ',newLogs);                         
        }else if(modo == 'Nuevo' && !fServChecked){
            let newLogs = logsActivo.slice();
            newLogs[0].fecha = '';
            newLogs[0].evento = {value:'', label:''};
            handleChenge({},'logsFServ',newLogs);                         
        }
    }, [fServChecked])

    return <div className={`${(tablaSeleccionada != 'fueraServicio') && 'inactive'} fueraServicioSubtablaDiv`}>
        <label>Disponibilidad</label>
        <div className={`${modo == 'Vista' ? 'fourColumns' : ''} subtablaHeader`}>
            {modo != 'Vista' && <label className="labeldelete"></label>}
            <label className="labelFecha">Fecha</label>
            <label className="labelEvento">Evento</label>
            <label className="labelTextAdic">Texto Adicional</label>
            <label className="laberUsername">Usuario</label>
            <label className="labelArchivo">Archivo</label>
        </div>
        <div className="bodyTable">
            {
                logsActivo.map((l, i) => <RRLogsFServ l={l} i={i} key={l.rowKey || i} usuario={usuario} opcionesUsers={opcionesUsers} handleChange={handleChange} handleDelete={handleDelete} fServChecked={fServChecked} lastElement={logsActivo.length - 1 == i ? true : false} modo={modo} archivoLog={fServFiles?.find(f => f.rowKey === l.rowKey && f.accion !== 'DELETE')} onFileChange={onFServFileChange}/>)
            }
        </div>
    </div>

}

export default React.memo(FueraServicioSubtabla);